<script lang="ts">
  import type { CategoryPropConfig } from '../../modules/projects/project.interface';
  import { Icon } from 'svelte-materialify';
  import ColorPicker from '../ColorPicker.svelte';

  export let value: string[] = [];
  export let categoryPropConfig: CategoryPropConfig;

  const { maxCount = 6 } = categoryPropConfig.requirements || {};

  function randomColor() {
    return `#${Math.floor(Math.random() * 16777215).toString(16)}`;
  }

  function addColor() {
    if (value.length >= maxCount) return;

    value = [...value, randomColor()];
  }

  function removeColor() {
    value = value.slice(0, -1);
  }
</script>

<p class="text-body-1 mb-1">Colors</p>
<div class="multi-cp">
  <div
    class="multi-cp-button-wrapper grey lighten-3"
    role="button"
    on:click={() => addColor()}
  >
    <Icon class="mdi mdi-plus" size="30px" />
  </div>
  <div class="multi-cp-colors">
    {#each value as color}
      <ColorPicker bind:color />
    {/each}
  </div>
  <div class="multi-cp-button-wrapper grey lighten-3" on:click={() => removeColor()}>
    <Icon class="mdi mdi-minus" size="30px" />
  </div>
</div>

<style lang="scss">
  .multi-cp {
    display: flex;
    height: 260px;
    border: 1px solid var(--theme-text-fields-border);
    border-radius: 4px;
    margin-bottom: 8px;
  }

  .multi-cp-colors {
    flex: 1;
    display: flex;
    border-left: 1px solid var(--theme-text-fields-border);
    border-right: 1px solid var(--theme-text-fields-border);
  }

  .multi-cp-button-wrapper {
    flex: 0 0 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
</style>
